import { forwardRef, type FunctionComponent, type HTMLAttributes } from 'react'

import { useTranslation } from '@dreamstack/i18n'
import {
  PropertyStatusOpenReservation,
  PROPERTY_STATUS_FREE,
} from '@dreamstack/real-estate-logic'
import { cn } from '@dreamstack/util/src/cn'

const badgeBaseClass =
  'rounded-full transform -rotate-12 h-px-96 w-px-96 text-yellow-700 bg-yellow-50 md:absolute md:h-px-160 md:w-px-160 md:left-[-150px] ml:left-[-250px] lg:h-px-196 lg:w-px-196 lg:left-[-196px] flex flex-col justify-center items-center top-0 left-0'

const badgeSubTextClass =
  'font-semibold text-px-9_4 leading-none md:mt-px-8 md:mb-px-8 md:text-px-13 lg:text-px-16'

const getStatusClass = (status: number) => {
  if (PropertyStatusOpenReservation.includes(status)) {
    return 'bg-accentroYellowLight-full text-accentroSecondaryBrown-full'
  }
  if (PROPERTY_STATUS_FREE.includes(status)) {
    return 'bg-accentroSuccessLight-full text-accentroSuccess-full'
  }
  return 'bg-accentroError-100 text-accentroError-full'
}

type StyledBadgeProps = HTMLAttributes<HTMLDivElement> & {
  status: number
}

export const StyledBadge = forwardRef<HTMLDivElement, StyledBadgeProps>(
  ({ status, className, children, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(badgeBaseClass, getStatusClass(status), className)}
      {...rest}
    >
      {children}
    </div>
  )
)

StyledBadge.displayName = 'StyledBadge'

export const StatusBadge: FunctionComponent = () => {
  const t = useTranslation()

  return (
    <StyledBadge status={0}>
      <div className={badgeSubTextClass}>{t('accentro:currently_still')}</div>
    </StyledBadge>
  )
}
